export default __webpack_public_path__ + "static/PMG_EGTB_MYRUMAH_PDS_AGENCY_ENG-ebf3b8d270623884b6043b8e6aa1d47c.pdf";